// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2zQik","calendarButtons":"ClockData_calendarButtons__1IPjt"};